import { ServiceRequestForm } from '@/components/services/ServiceRequestForm'

export default function ServiceRequestScreen() {
  return <ServiceRequestForm />
}
